//
// LayoutOverlayMap.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BaseLayoutOverlay";
import "../core/AbstractLayoutOverlayMapLayer";
import "../layoutOverlay/Overlay";
import "./LayoutOverlayMapViewportOptions";
import "../overview/Overview";

var LayoutOverlayMap = createModule("gtl::LayoutOverlayMap", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::Layout","gtl::BaseLayoutOverlay"], EventDispatcher, [
    ,
    {
        overview: 1,
        convertPinState: 2,
        lockNavigation: 2,
        content: [1],
        clip: [1],
        viewportOptions: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LayoutOverlayMap;
